/* eslint-disable */

export const notEmpty = <T>(value: T | null | undefined): value is T =>
  value !== null && value !== undefined;

export const isFunction = <T extends (...arg: any[]) => any>(value: any): value is T =>
  typeof value === 'function';
